module.exports = __webpack_public_path__ + "static/media/sf-test-5.9b0f94d0.mp3";